import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-green/15" data-id="element-406">
    <div className="flex items-center mb-4" data-id="element-407">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-green font-serif font-bold text-sm md:text-xl border border-brand-green/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-408">
        {initials}
      </div>
      <div data-id="element-409">
        <div className="flex text-brand-celesteDark mb-1 text-[15px]" data-id="element-410">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-411" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-412">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-413">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] font-serif leading-relaxed" data-id="element-414">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    text: 'El protocolo de insomnio reactivo cambió mis sesiones. Ahora tengo un algoritmo claro y mis pacientes mejoran desde la segunda consulta.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    text: 'El Bonus de Auxilio Inmediato me salvó. Tuve una paciente con crisis de pánico en plena sesión y pude contenerla con el protocolo paso a paso.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'La Plata',
    text: 'El tomo de alimentos por cuadro es lo que más valoran mis pacientes. Se van con un plan concreto y el tratamiento avanza mucho más rápido.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-415">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-416">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-417" />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Kit MTC + Maestría',
    text: 'Los protocolos con algoritmo de 3 pasos me dieron la seguridad que necesitaba. Ahora entro a cada sesión sabiendo exactamente qué hacer.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Acupunturista',
    text: 'Con el Protocolo de Cierre de Sesión de la Maestría, mis pacientes reservan el próximo turno antes de irse. Eso no pasaba nunca.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'La Plata',
    product: 'Terapeuta en MTC',
    text: 'La ficha del paciente parece simple pero es lo que más uso. En una sola hoja tengo todo lo que necesito para arrancar con claridad total.'
  }, {
    initials: 'RA',
    name: 'Ricardo A.',
    location: 'Mendoza',
    product: 'Terapeuta Holístico',
    text: 'La guía de hierbas en Argentina es un recurso que no existía en ningún lado. Por primera vez sé exactamente qué recomendar y dónde conseguirlo.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-418">
      <div className="text-center mb-12" data-id="element-419">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-greenDark pt-[0px]" data-id="element-420">
          ❤️ MÁS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] max-w-4xl mx-auto" data-id="element-421">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-422" />)}
      </div>
    </Section>;
};